<template>
  <div class="home_top">
    <div class="home_top_container">
      <div class="title_left">
        <img class="title_left_img" src="../assets/images/home_company_top.png">
        <div class="title_left_text" @click="toTest">富从智能</div>
      </div>
      <div class="title_right">
        <div class="right_item" @click="toHome">首页</div>
        <div class="right_item" @click="toCompanyProfile">公司简介</div>
        <div class="right_item" @click="toProjectDesc">产品说明</div>
        <div class="right_item" @click="toProjectCase">项目案例</div>
        <div class="right_item" @click="toService">联系我们</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
    toService: function () {
      this.$router.push('/AfterSalesService')
    },
    toProjectCase: function () {
      this.$router.push('/ProjectCase')
    },
    toProjectDesc: function () {
      this.$router.push('/ProjectDescription')
    },
    toCompanyProfile: function () {
      this.$router.push('/CompanyProfile')
    },
    toHome: function () {
      this.$router.push('/Home')
    },
    toTest: function () {
      // this.$router.push('/Test')
    }
  }
};
</script>

<style lang="less" scoped>

@import "../assets/css/common";

@media screen and (max-width: 650px) {
  .home_top {
    width: 100%;
    height: @layoutTopHight1280;
    overflow: scroll;
  }

  .title_left {
    margin-left: 166px;
  }

  .title_right {
    margin: 0px 200px 0px 120px;
  }

  .title_left_text {
    width: 100px;
    font-size: 22px;
  }

  .title_left_img {

  }
}

@media screen  and (min-width: 650px)  and (max-width: 1280px) {

  .home_top {
    width: 100%;
    height: @layoutTopHight1280;
  }

  .title_left {
    margin-left: 166px;
  }

  .title_right {
    margin: 0px 200px 0px 120px;
  }

  .title_left_text {
    width: 100px;
    font-size: 22px;
  }

  .title_left_img {

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .home_top {
    width: @screenWidth1440;
    height: @layoutTopHight1440;
  }

  .title_left {
    margin-left: 155px;
  }

  .title_right {
    margin: 0px 225px 0px 135px;
  }

  .title_left_text {
    font-size: 30px;
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .home_top {
    width: @screenWidth1920;
    height: @layoutTopHight1920;
  }

  .title_left {
    margin-left: 248px;
  }

  .title_right {
    margin: 0px 300px 0px 180px;
  }

  .title_left_text {
    font-size: 36px;
  }

}


.home_top {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  background: #ffffff;
  z-index: 1000;

  .home_top_container {
    display: flex;
    width: 100%;
    height: 100%;
    box-shadow: 1px 2px 10px #333;

    .title_left {
      display: flex;
      padding: 20px 0;

      .title_left_img {

      }

      .title_left_text {
        white-space: nowrap;
        color: #6090C0;
        font-family: FZLBJW--GB1-0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .title_right {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-family: SourceHanSansCN-Medium;


      .right_item {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 120px;
        height: 100%;
        cursor: pointer;
        color: #333333;
      }

      .right_item:hover {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 120px;
        height: 100%;
        cursor: pointer;
        background: #2A57EA;
        color: white;
      }


    }

  }
}


</style>
